import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers, setTokenHeader, renderRedirect, getJwtFromCookies, isExpiredJwt, getUsernameJwt } from "../../module_auth/AuthService"
import parse from 'html-react-parser';
import { formatDate, handleRefresch, sendGoogleAnalytics } from "../../component/common/BaseUtil"
import { useNavigate } from "react-router-dom";
import { COMMENT_MESSAGE_NO_AUTH, getCatgNameByValue, getCatgUrlByValue } from './CmtyConstant'
import { ToastMessage } from "../../component/common/Toast"
import { CmtyBaseComment } from './CmtyBaseComment'
import { ModalMessage } from "../../component/common/Modal"
import { useLocation } from "react-router-dom";

//icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faReply, faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faClock, faUser, faComment, faHeart } from '@fortawesome/free-regular-svg-icons';

export function CmtyBasePost() {
    const location = useLocation();
    const navigate = useNavigate();

    const queryParameters = new URLSearchParams(window.location.search)
    const cmtyPostId = queryParameters.get("id") == null ? 1 : queryParameters.get("id")

    const [cmtyCatgUrl, setCmtyCatgUrl] = useState("");
    const [cmtyCatgName, setCmtyCatgName] = useState("");

    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [accessToken, setAccessToken] = useState("");

    const [hiddenCommentTextField, setHiddenCommentTextField] = useState(true);
    const [hiddenCommentCancelBtn, setHiddenCommentCancelBtn] = useState(true);

    const [hiddenEditDeleteBtn, setHiddenEditDeleteBtn] = useState(true);

    //포스팅 상세
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [updateAt, setUpdateAt] = useState("");
    const [hits, setHits] = useState(0);
    const [nickname, setNickname] = useState("");
    const [username, setUsername] = useState("");
    const [totalCommentCount, setTotalCommentCount] = useState(0);
    //End 포스팅 상세

    //공감
    const [likeCount, setLikeCount] = useState(0);
    const [likeExit, setLikeExist] = useState(false);

    //댓글 리스트업
    const [cmtyCommentList, setCmtyCommentList] = useState([]);

    //modal
    const [showModalLogin, setShowModalLogin] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    const [commentPlaceHolderMessage, setCommentPlaceHolderMessage] = useState("");
    const [cmtyComment, setCmtyComment] = useState("");
    const [cmtyCommentDisabled, setCmtyCommentDisabled] = useState(false);

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)

        if (getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())) {
            //1.login
            setRedirectUrl('/login')
            //2.cmty_post after login
            setCommentPlaceHolderMessage(COMMENT_MESSAGE_NO_AUTH)
            setCmtyCommentDisabled(true)
            //setHiddenCommentTextField(true)
        } else {
            //1.cmty_post
            setAccessToken(getJwtFromCookies())
            setCommentPlaceHolderMessage("")
            setCmtyCommentDisabled(false)
            //setHiddenCommentTextField(false)
            loadCmtyLikeExist()
        }

        loadCmtyPost()
        loadCmtyCommentList()
        loadCmtyLikeCount()
    }, []);

    function loadCmtyLikeExist() {
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/check/exit/cmty/like/mbr',
            {
                method: 'post', headers,
                body: JSON.stringify({
                    cmtyPostId: cmtyPostId
                })
            })
            .then(response => response.json())
            .then(response => {
                if (response.validRequest) {
                    setLikeExist(response.valueBoolean)
                } else {

                }
            }).catch(function (error) {
                console.log(error);
            });
    }

    function loadCmtyLikeCount() {
        let url = basePort + '/get/cmty/like/count/' + cmtyPostId
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setLikeCount(response.valueLong)
            }).catch(function (error) {
                console.log(error);
            });
    }

    function loadCmtyPost() {
        let url = basePort + '/get/cmty/post/' + cmtyPostId
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setTitle(response.title)
                setContent(response.content)
                setUpdateAt(response.updateAt)
                setHits(response.hits)
                setNickname(response.nickname)
                setUsername(response.username)
                setTotalCommentCount(response.totalCommentCount)
                setCmtyCatgName(getCatgNameByValue(response.catg))
                setCmtyCatgUrl(getCatgUrlByValue(response.catg))
                console.log(getUsernameJwt(getJwtFromCookies()))
                console.log(username)
                if (getUsernameJwt(getJwtFromCookies()) === response.username) {
                    setHiddenEditDeleteBtn(false)
                } else {
                    setHiddenEditDeleteBtn(true)
                }
            }).catch(error => console.log(error))
    }

    function loadCmtyCommentList() {
        let url = basePort + '/get/cmty/comment/views/' + cmtyPostId
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setCmtyCommentList(response)
                console.log("commentList: " + response)
            }).catch(error => console.log(error))
    }

    function backToList() {
        let page = localStorage.getItem("page")
        let pageList = page == null ? 1 : page
        let url = cmtyCatgUrl + "?page=" + pageList;
        navigate(url);
    }

    function fadeOutToast(msg) {
        setToastMessage(true, msg)
        setTimeout(function () {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message) {
        setShowToast(show)
        setMsgToast(message)
    }

    function handleCmtyComment(event) {
        console.log(event.target.value)
        setCmtyComment(event.target.value);
    }

    function clickPostEdit(event) {
        setRedirectUrl('/cmty_edit_post?id=' + cmtyPostId)
        setRedirect(true)
    }

    //공감 등록
    function clickLike(event) {
        if (accessToken) {
            setTokenHeader(getJwtFromCookies())
            fetch(basePort + '/post/cmty/like',
                {
                    method: 'post', headers,
                    body: JSON.stringify({
                        cmtyPostId: cmtyPostId,
                    })
                })
                .then(response => response.json())
                .then(response => {
                    if (response.validRequest) {
                        fadeOutToast(response.validationMessage)
                        setTimeout(function () {
                            handleRefresch()
                        }.bind(this), 1000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
        } else {
            clickModalLoginBtn()
        }
    }

    function clickPostCommment(event) {
        if (accessToken) {
            //post comment!
            event.preventDefault();
            setTokenHeader(getJwtFromCookies())
            fetch(basePort + '/comment/cmty',
                {
                    method: 'post', headers,
                    body: JSON.stringify({
                        content: cmtyComment,
                        cmtyPostId: cmtyPostId
                    })
                })
                .then(response => response.json())
                .then(response => {
                    if (response.validRequest) {
                        fadeOutToast(response.validationMessage)
                        setTimeout(function () {
                            handleRefresch()
                        }.bind(this), 3000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
        } else {
            clickModalLoginBtn()
        }
    }

    function closeModalLoginBtn() {
        setShowModalLogin(false)
    }

    function submitModalLoginBtn() {
        setShowModalLogin(false)
        setRedirectUrl('/login')
        setRedirect(true)
    }

    function clickModalLoginBtn() {
        setShowModalLogin(true)
    }

    function closeModalDeleteBtn() {
        setShowModalDelete(false)
    }

    function clickModalDeleteBtn() {
        setShowModalDelete(true)
    }

    function submitModalDeleteBtn() {
        setShowModalDelete(false)
        clickPostDelete()
    }
    //삭제 등록
    function clickPostDelete(event) {
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/delete/cmty/post',
            {
                method: 'post', headers,
                body: JSON.stringify({
                    cmtyPostId: cmtyPostId,
                })
            })
            .then(response => response.json())
            .then(response => {
                if (response.validRequest) {
                    fadeOutToast(response.validationMessage)
                    setTimeout(function () {
                        backToList()
                    }.bind(this), 1000)
                } else {
                    fadeOutToast(response.validationMessage)
                }
            }).catch(function (error) {
                console.log(error);
            });
    }

    function hideCommentTextField() {
        setHiddenCommentTextField(true)
        setHiddenCommentCancelBtn(true)
    }


    return (
        <div>
            {renderRedirect(redirect, redirectUrl)}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>커뮤니티</span></li>
                            <li class="breadcrumb-item"><span>{cmtyCatgName}</span></li>
                        </ol>
                    </div>
                    <div class="container">
                        <div class="card border-light" style={{ marginBottom: '10px', marginTop: '10px' }}>
                            <div class="card-body">
                                <h4 class="card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', marginBottom: '20px' }}>{title}</h4>
                                <div class="row" style={{ marginBottom: "30px" }}>
                                    <label class="form-label">
                                        <span>
                                            <FontAwesomeIcon icon={faUser} /> {nickname}
                                            <FontAwesomeIcon icon={faEye} style={{ marginLeft: "10px" }} /> {hits}
                                            <FontAwesomeIcon icon={faClock} style={{ marginLeft: "10px" }} /> {formatDate(updateAt)}
                                        </span>
                                    </label>
                                </div>
                                <hr class="my-4" />
                                {/* 본문 */}
                                <p class="card-text">
                                    <span style={{
                                        color: '#222222',
                                        whiteSpace: 'pre-wrap',   // 줄바꿈 보존 + 너비를 넘어가면 자동 줄바꿈
                                        wordBreak: 'break-all',   // 긴 단어도 잘리지 않게 처리
                                        fontFamily: 'inherit'     // 부모 요소의 글씨체 상속
                                    }}>
                                        {/* <pre>{parse(content)}</pre> */}
                                        {parse(content)}
                                    </span><br /><br />
                                </p>
                                {/* 공감 */}
                                <div class="container" style={{ textAlign: 'center', maxWidth: '700px', marginBottom: '10px' }}>
                                    <button class="btn btn-light" type="button" style={{ borderRadius: '5px 0 0 5px' }} onClick={clickLike} hidden={!likeExit}>
                                        <FontAwesomeIcon style={{ color: 'red' }} icon={solidHeart} />  공감
                                    </button>
                                    <button class="btn btn-light" type="button" style={{ borderRadius: '5px 0 0 5px' }} onClick={clickLike} hidden={likeExit}>
                                        <FontAwesomeIcon icon={faHeart} />  공감
                                    </button>
                                    <button class="btn btn-light" type="button" style={{ borderRadius: '0 5px 5px 0', marginLeft: '0.5px' }} disabled>{likeCount} 명</button>
                                </div>
                                <hr class="my-4" />
                                {/* 댓글 리스트:포스팅에 다는 글 */}
                                <div class="row" style={{ marginBottom: "30px" }}>
                                    <label class="form-label">
                                        <span>
                                            <FontAwesomeIcon icon={faComment} style={{ marginLeft: "10px" }} /> 댓글 {totalCommentCount}
                                        </span>
                                    </label>
                                </div>
                                <ul class="list-group list-group-flush">
                                    {cmtyCommentList.map((object, index) => (
                                        <CmtyBaseComment object={object} index={index} />
                                    ))}
                                </ul>
                            </div>
                            <div class="card-body">
                                <div class="input-group mb-3">
                                    <textarea class="form-control" placeholder={commentPlaceHolderMessage} aria-label="Message" onChange={handleCmtyComment} disabled={cmtyCommentDisabled}></textarea>
                                    <button type="button" class="btn btn-secondary" style={{ fontSize: "12px", borderRadius: '0 5px 5px 0' }} onClick={clickPostCommment}>댓글쓰기</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container d-flex d-sm-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center"
                        style={{ marginTop: '15px' }}>
                        <nav>
                            <ul class="pagination">
                                <li class="page-item text-center d-flex d-md-flex d-xxl-flex justify-content-center justify-content-md-center align-items-md-center"
                                    style={{ textAlign: 'center' }} onClick={backToList}>
                                    <button type="button" class="btn btn-primary" style={{ borderRadius: '5px', marginRight: "5px" }}>목록</button>
                                </li>
                                <li class="page-item text-center d-flex d-md-flex d-xxl-flex justify-content-center justify-content-md-center align-items-md-center"
                                    style={{ marginLeft: "10px", textAlign: 'center' }} onClick={clickPostEdit} >
                                    <button type="button" class="btn btn-secondary" style={{ borderRadius: '5px', marginRight: "5px" }} hidden={hiddenEditDeleteBtn}>수정</button>
                                </li>
                                <li class="page-item text-center d-flex d-md-flex d-xxl-flex justify-content-center justify-content-md-center align-items-md-center"
                                    style={{ marginLeft: "10px", textAlign: 'center' }} onClick={clickModalDeleteBtn} >
                                    <button type="button" class="btn btn-danger" style={{ borderRadius: '5px', marginRight: "5px" }} hidden={hiddenEditDeleteBtn}>삭제</button>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <ToastMessage show={showToast} msg={msgToast} />
                    <ModalMessage show={showModalLogin} closeBtn={closeModalLoginBtn}
                        submitBtn={submitModalLoginBtn} title={"로그인이 필요합니다."} msg={"로그인 페이지로 안내해 드릴까요?"} />
                    <ModalMessage show={showModalDelete} closeBtn={closeModalDeleteBtn}
                        submitBtn={submitModalDeleteBtn} title={"삭제 확인"} msg={"정말로 이 항목을 삭제하시겠습니까?"} />
                </section>
            </main>
        </div>
    );
}